import HeatmapGrid from "./heatmap-grid";

export default HeatmapGrid;
